var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVanShuttle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M628.875 210.625L494.391 49.268C485.271 38.326 471.762 32 457.518 32H48C21.6 32 0 53.6 0 80V336C0 362.4 21.6 384 48 384H64C64 437 107 480 160 480S256 437 256 384H384C384 437 427 480 480 480S576 437 576 384H592C618.4 384 640 362.4 640 336V241.375C640 230.125 636 219.25 628.875 210.625ZM64 192V96H160V192H64ZM160 432C133.5 432 112 410.5 112 384S133.5 336 160 336S208 357.5 208 384S186.5 432 160 432ZM320 192H224V96H320V192ZM480 432C453.5 432 432 410.5 432 384S453.5 336 480 336S528 357.5 528 384S506.5 432 480 432ZM384 192V96H450L530 192H384Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVanShuttle);
export default __webpack_public_path__ + "static/media/van-shuttle.b9a2f683ef311ed5f0ce0a6552b00b25.svg";
export { ForwardRef as ReactComponent };